import { createAction } from '@reduxjs/toolkit'

export enum APRCalculatorField {
  LOWEST_PRICE_CHANGE = 'LOWEST_PRICE_CHANGE',
  HIGHEST_PRICE_CHANGE = 'HIGHEST_PRICE_CHANGE',
}

// Set price change values (always positive internally but lowest displayed with a minus)
export const setLowestPriceChange = createAction<{ value: number }>('staking/setLowestPriceChange')
export const setHighestPriceChange = createAction<{ value: number }>('staking/setHighestPriceChange')

// Toggle custom range on/off
export const setUseCustomRange = createAction<{ enabled: boolean }>('staking/setUseCustomRange')

// Toggle showing expired incentives
export const setShowExpiredIncentives = createAction<{ show: boolean }>('staking/setShowExpiredIncentives')

// Reset to default values
export const resetAPRCalculator = createAction<void>('staking/resetAPRCalculator')
